import loadable from '@loadable/component';

export const ViewJobPageLoadable = loadable(() => import('./ViewJobPage'), {
  resolveComponent: (module) => module.ViewJobPage,
});
